import {Injectable} from '@angular/core';
import {combineLatest} from 'rxjs';
import {map, take} from 'rxjs/operators';

import {NavigationService} from '../services/navigation.service';
import {AuthFacade} from '../store/auth-state/+state/auth.facade';

@Injectable({
	providedIn: 'root'
})
export class DigitalBoardGuard {
	constructor(
		private authFacade: AuthFacade,
		private navService: NavigationService
	) {}

	canActivate() {
		return combineLatest([
			this.authFacade.isLoggedIn$,
			this.authFacade.userData$
		]).pipe(
			take(1),
			map(([isLoggedIn, userData]) => {
				if (!isLoggedIn || !userData) {
					this.navService.login();
					return false;
				}
				// Allow access even with empty venues so the page can render a
				// localized "no venue assigned" message instead of bouncing.
				return true;
			})
		);
	}
}
